// extracted by mini-css-extract-plugin
module.exports = {"contentTitle":"CheckContent_contentTitle__3AFry","contentAddress":"CheckContent_contentAddress__2fO4X","contentFooterText":"CheckContent_contentFooterText__1-ajg"};